import { i18n } from "../i18n.js";
import _ from "lodash";

const makeQueryFromObject = data => {
  var query = "";
  for (var key in data) {
    if (data[key]) {
      query += key + "=" + data[key] + "&";
    }
  }
  return query.trim("&");
};
const mergeDenyRules = (target = {}, object = {}) => {
  let merged = _.cloneDeep(target);
  Object.keys(object).forEach(key => {
    if (!merged.hasOwnProperty(key)) {
      merged[key] = object[key];
    } else if (object[key]) {
      if (_.isArray(object[key])) {
        object[key].forEach(val => {
          if (merged[key].indexOf(val) < 0) {
            merged[key].push(val);
          }
        });
      } else if (_.isObject(object[key])) {
        merged[key] = { ...merged[key], ...object[key] };
      } else {
        merged[key] = object[key];
      }
    }
  });
  return merged;
};

const getMediaUrl = (path, baseUrl) => {
  if (path.match(/^(#|\/\/|https?:\/\/|(mailto|tel|sms):)/gm)) {
    return path;
  }
  return baseUrl.rtrim("/") + "/" + path.ltrim("/");
};

const validateInput = (value, label, min = null, max = null) => {
  value = value.replace(",", ".");
  if (value == "") {
    return { valid: false, msg: i18n.t("Please input {label}!", { label }) };
  }
  if (isNaN(value)) {
    return {
      valid: false,
      msg: i18n.t("{label} must be a number!", { label })
    };
  }
  if (min && parseFloat(value) < min) {
    return {
      valid: false,
      msg: i18n.t("{label} must be greater than {min}", { label, min })
    };
  }
  if (max && parseFloat(value) > max) {
    return {
      valid: false,
      msg: i18n.t("{label} must be smaller than {max}", { label, max })
    };
  }
  return { valid: true, msg: "", number: parseFloat(value) };
};

const computeCustomFormatLabel = (system, width, height, packagingValues) => {
  const packing = typeof packagingValues !== "undefined" ? packagingValues : {};
  const packingString = Object.values(packing).join(" x ");

  if (packingString.length) {
    const inputUnit = system == "imperial" ? "in" : "mm";
    return i18n.t("Custom Format ({format} {measurement})", {
      format: packingString,
      measurement: inputUnit
    });
  }
  if (system == "imperial") {
    return (
      i18n.t("Custom Format") + " (" + width + '"' + " x " + height + '"' + ")"
    );
  } else {
    return (
      i18n.t("Custom Format") + " (" + width + " x " + height + " " + "cm" + ")"
    );
  }
};

export {
  makeQueryFromObject,
  validateInput,
  getMediaUrl,
  computeCustomFormatLabel,
  mergeDenyRules
};
